
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';

/**
 * 艺人监管（平台端，挂在活动下）
 * 入驻档案 + 已建团体同一页；字典（分类/标签/角色）在基础数据
 * 主入口 /artist/profile；/artist/group 仍指向同一监管页（兼容旧菜单/权限）
 */
const artistRouter: RouteRecordRaw = {
  path: `${roterPre}/artist`,
  name: 'Artist',
  component: Layout,
  alwaysShow: true,
  meta: {
    title: '文化艺术',
    icon: 'collection',
  },
  children: [
    {
      path: 'profile',
      name: 'ArtistProfile',
      meta: {
        title: '艺人监管',
        noCache: true,
      },
      component: () => import('@/views/_expand/artist/supervise/index.vue'),
    },
    {
      path: 'group',
      name: 'ArtistGroup',
      meta: {
        title: '艺人监管',
        noCache: true,
        activeMenu: `${roterPre}/artist/profile`,
      },
      component: () => import('@/views/_expand/artist/supervise/index.vue'),
    },
    {
      path: 'category',
      name: 'ArtistCategory',
      meta: {
        title: '团体分类',
        noCache: true,
      },
      component: () => import('@/views/_expand/artist/category/index.vue'),
    },
    {
      path: 'tag',
      name: 'ArtistTag',
      meta: {
        title: '艺人标签',
        noCache: true,
      },
      component: () => import('@/views/_expand/artist/group/tag.vue'),
    },
    {
      path: 'role',
      name: 'ArtistRole',
      meta: {
        title: '艺术角色',
        noCache: true,
      },
      component: () => import('@/views/_expand/artist/group/role.vue'),
    },
  ],
};

export default artistRouter;
